import { SvgIcon } from '@mui/material';
import {  observer } from 'mobx-react';
import React, { Component } from 'react';
import { IPropsSvgIcone } from '../../modelo/Icone';



class IcondeEstruturas extends Component<IPropsSvgIcone> {

    render() {
        return (
            <SvgIcon {...this.props}>

                <path fill={this.props.htmlColor || 'currentColor'}
                    d="M 20.05,19.98
                    C 20.98,19.97 21.02,16.01 20.02,16.02
                    20.02,16.02 16.01,16.01 16.01,16.01
                    15.02,16.01 14.99,20.00 16.01,20.01
                    16.01,20.01 20.05,19.98 20.05,19.98 Z
                    M 4.00,10.00
                    C 4.00,10.00 8.02,10.02 8.02,10.02
                    9.01,10.02 9.01,13.99 8.01,14.00
                    8.01,14.00 4.04,14.00 4.04,14.00
                    3.01,14.01 3.03,9.99 4.00,10.00 Z
                    M 4.01,4.01
                    C 3.01,4.00 3.01,8.00 4.01,7.99
                    4.01,7.99 20.00,8.00 20.00,8.00
                    20.97,7.99 20.99,4.00 20.00,4.01
                    20.00,4.01 4.01,4.01 4.01,4.01 Z
                    M 11.00,10.02
                    C 10.01,10.02 10.01,13.98 11.00,13.98
                    11.00,13.98 20.03,13.99 20.03,13.99
                    21.00,13.99 21.00,10.01 20.02,10.00
                    20.02,10.00 11.00,10.02 11.00,10.02 Z
                    M 13.02,16.02
                    C 14.01,16.01 13.99,19.98 13.02,19.98
                    13.02,19.98 4.01,20.01 4.01,20.01
                    3.02,20.01 3.01,16.00 4.00,16.01
                    4.00,16.01 13.02,16.02 13.02,16.02 Z"
                />
            </SvgIcon>
        );
    }
}

export default observer(IcondeEstruturas);
